import { createContext } from 'react';

const BulkUploadPageContext = createContext({
  stepBackFunc: () => {},
  stepForwardFunc: () => {},
  goToStep: () => {},
});

export const PayAndBookContext = createContext({
  currency: {},
  code: '',
  totalDiscount: 0,
  totalOriginalFare: 0,
  totalFinalFare: 0,
});

export default BulkUploadPageContext;
